// src/lib/normalize.ts

// Conjunto A (códigos curtos) — comum: { M, F, O, N }
const SEX_SET_A = ["M", "F", "O", "N"] as const;
// Conjunto B (nomes em pt) — comum: { masculino, feminino, outro, nao_informado }
const SEX_SET_B = ["masculino", "feminino", "outro", "nao_informado"] as const;

export type SexA = typeof SEX_SET_A[number];
export type SexB = typeof SEX_SET_B[number];

export function normalizeSexToA(input?: string | null): SexA | null {
  if (!input) return null;
  const v = input.toString().trim().toLowerCase();
  if (["m","masculino","male","homem"].includes(v)) return "M";
  if (["f","feminino","female","mulher"].includes(v)) return "F";
  if (["o","outro","other","não-binárie","nao-binario","nao-binária","nao-binaria"].includes(v)) return "O";
  if (["n","nao_informado","não informado","nao informado","prefiro nao dizer","prefiro não dizer","indefinido","any"].includes(v)) return "N";
  return null;
}

export function normalizeSexToB(input?: string | null): SexB | null {
  if (!input) return null;
  const v = input.toString().trim().toLowerCase();
  if (["m","masculino","male","homem"].includes(v)) return "masculino";
  if (["f","feminino","female","mulher"].includes(v)) return "feminino";
  if (["o","outro","other","não-binárie","nao-binario","nao-binária","nao-binaria"].includes(v)) return "outro";
  if (["n","nao_informado","não informado","nao informado","prefiro nao dizer","prefiro não dizer","indefinido","any"].includes(v)) return "nao_informado";
  return null;
}

export function isSexConstraintError(err?: { message?: string | null } | null) {
  const msg = err?.message || "";
  return /check constraint/i.test(msg) && /(sexo|sex)/i.test(msg);
}
